module.exports = __webpack_public_path__ + "img/Insulinegray.9df85b76.svg";